import userInfo from 'hubspotter-http/hubSpotterInfo';
import { once } from 'usage-tracker-core/common/helpers';
const getHubspotterInfo = () => userInfo({
  ignoreRedirect: true
});

// In some cases, the HubSpotterInfo has no e-mail, for example, when it is a System User
// or an Internal Acceptance Test User. In this case we still want to have their e-mail
// as we still wish to proceed with the tracking of the Event
const hubspotterEmail = ({
  hubspotter
}) => hubspotter.email || (
// In case there's no e-mail but there's an username we use that info
hubspotter.username ? `${hubspotter.username}@hubspot.com` : null);
const getEmail = () => getHubspotterInfo().then(hubspotterEmail);

// This prevents the HubSpotter User Info from being requested multiple times
// instead it is requested only once, which should reduce unnecessary calls
export const getEmailOnce = once(getEmail);